var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('h1',{staticClass:"page-title__text"},[_vm._v(_vm._s(_vm.displayTitle))]),_vm._v(" "),(_vm.subtitle)?_c('p',{staticClass:"page-title__sub"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae14d65a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header-Title.vue
// module id = ne0v
// module chunks = 1